{
  "version": "1.0",
  "forms": [
    {
      "id": "0",
      "title": "Sign Up for Atlantic Alerts",
      "groups": [
        {
          "fields": [
            {
              "id": "first-name",
              "isRequired": true,
              "requiredMessage": "First Name is required",
              "label": "First Name",
              "name": "firstName",
              "type": "text"
            }
          ]
        },
        {
          "fields": [
            {
              "id": "last-name",
              "isRequired": true,
              "requiredMessage": "Last Name is required",
              "label": "Last Name",
              "name": "lastName",
              "type": "text"
            }
          ]
        },
        {
          "fields": [
            {
              "id": "email",
              "isRequired": true,
              "requiredMessage": "Email is required",
              "invalidMessage": "Please enter a valid email",
              "label": "Email",
              "name": "email",
              "type": "email"
            }
          ]
        },
        {
          "fields": [
            {
              "id": "mobile-phone",
              "isRequired": false,
              "invalidMessage": "Please enter a valid phone number",
              "label": "Mobile Phone",
              "name": "mobilePhone",
              "type": "tel"
            }
          ]
        }
      ]
    }
  ]
}
